/**
 * NB: le variabili dello schema colori sono esportate a livello di vue.config.js tramite lo pseudoselettore :export
 * per eventuali altre variabili site-specific, aggiungere un altro :export dentro '@running_app_src/scss/abstract/_custom.scss'
 */
import * as exported_sass_variables from '@running_app_src/scss/abstract/_custom.scss'
import { get_config } from './commons'

export default {
  methods: {
    /**
     * senza parametri ritorna un oggetto con tutte le variabili esportate
     */
    sass: (key = false) => {
      const color_schema = {
        ...exported_sass_variables,
        ...get_config().guiSettings.customizations || {},
      }
      if (key == false) return color_schema
      let value = color_schema[key]
      return value == undefined ? '' : value
    }
  }
}